import { type FC, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../generic-hooks'
import { useGlobalConfigContext } from '../../global-config'
import {
  LoginRegistrationRegistrationModal,
  LoginRegistrationRegistrationStateProvider,
} from '../../login-registration'
import { TENANT } from '../../tenant'

import { LoginRegistrationRegistrationBoxFooter } from './LoginRegistrationRegistrationBoxFooter/LoginRegistrationRegistrationBoxFooter'

export const LoginRegistrationRegistrationSection: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const [isProfessionalRegistration, setIsProfessionalRegistration] =
    useState(false)
  const { handleClose, handleOpen, isOpen } = useOpenableControls(false)
  useEffect(() => {
    if (window.location.hash === '#register') {
      handleOpen()
    }
  }, [handleOpen])

  return (
    <div className="z-0 basis-1/2 bg-light-primary-medium tablet:ml-3 tablet:mr-6">
      <div className="flex-1 bg-light-primary-medium p-5 tablet:rounded-m tablet:shadow-m">
        <h2 className="mb-6 text-l font-medium">
          <FormattedMessage id="login.createAccount.headline" />
        </h2>
        <Button
          className="mb-5 w-full"
          data-qa-id="form-register"
          onClick={() => {
            setIsProfessionalRegistration(false)
            handleOpen()
          }}
          size="large"
          variant="filled"
        >
          <FormattedMessage id="login.createAccount.button" />
        </Button>
        {new Set<TENANT>([TENANT.BE]).has(tenant) && (
          <Button
            className="mb-5 w-full"
            color="secondary"
            data-qa-id="form-professionalAccountRegistrationButton"
            onClick={() => {
              setIsProfessionalRegistration(true)
              handleOpen()
            }}
            size="large"
          >
            <FormattedMessage id="professional.createAccount.button" />
          </Button>
        )}
        <LoginRegistrationRegistrationBoxFooter />
      </div>
      <div className="p-5 text-dark-primary-strong">
        <FormattedMessage id="login.disclaimer" />
      </div>
      <LoginRegistrationRegistrationStateProvider
        isProfessionalRegistration={isProfessionalRegistration}
      >
        <LoginRegistrationRegistrationModal
          isOpen={isOpen}
          onClose={handleClose}
        />
      </LoginRegistrationRegistrationStateProvider>
    </div>
  )
}
